import apiClient from './client.js';

function filenameFromContentDisposition(header) {
  if (!header) return null;
  const m = header.match(/filename="([^"]+)"/i);
  return m ? m[1] : null;
}

export const listTerminationsByContract = async (contractId) => {
  const { data } = await apiClient.get(`/contracts/${contractId}/terminations`);
  return data;
};

export const createTermination = async (contractId, payload) => {
  const { data } = await apiClient.post(`/contracts/${contractId}/terminations`, payload);
  return data;
};

export const sendTerminationForSignature = async (id) => {
  const { data } = await apiClient.post(`/terminations/${id}/send`);
  return data;
};

export const deleteTermination = async (id) => {
  const { data } = await apiClient.delete(`/terminations/${id}`);
  return data;
};

export const downloadTerminationPdf = async (id, fallbackFilename) => {
  const resp = await apiClient.get(`/terminations/${id}/pdf`, { responseType: 'blob' });
  const name = filenameFromContentDisposition(resp.headers['content-disposition']) || fallbackFilename || `termination-${id}.pdf`;
  const url = URL.createObjectURL(resp.data);
  const a = document.createElement('a');
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
};
